
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BookMarkSolidIcon from 'Components/icons/BookMarkSolidIcon/BookMarkSolidIcon';
import BookMarkLightIcon from 'Components/icons/BookMarkLightIcon/BookMarkLightIcon';
import { COLORS } from "Constants/BIDashboardConstants"
export class BookMarkIcon extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (

      <span key={this.props.id} onClick={this.props.toggleBookMark}>
        {
          this.props.isBookMarked ? <BookMarkSolidIcon color={COLORS.oneGp.globalBlue} height={this.props.height} width={this.props.width} /> :
            <BookMarkLightIcon width={this.props.width} height={this.props.height} />
        }
      </span>
    );
  }
}
BookMarkIcon.propTypes = {
  isBookMarked: PropTypes.bool,
  toggleBookMark: PropTypes.func,
  height: PropTypes.number,
  width: PropTypes.number,
};

BookMarkIcon.defaultProps = {
  toggleBookMark: () => { },
};
export default BookMarkIcon;
